import { clsx } from 'clsx';
import { FC } from 'react';
import { P } from 'atoms/Typography';
import { gtmPushFooterNavigation } from 'modules/gtm/modules/sections/navigation/navigation';
import { Item } from './Item';
import { IColumnContent } from './types';
import styles from './styles.module.css';

export const ColumnContent: FC<IColumnContent> = ({
  column,
  className = '',
  children,
}) => {
  const handleLinkClick = (
    columnTitle: string | undefined,
    itemTitle: string,
  ) => {
    gtmPushFooterNavigation(columnTitle, itemTitle);
  };

  return (
    <div className={clsx(styles.column, className)}>
      <P className={styles.title}>{column.title}</P>
      <ul className={styles.list}>
        {column?.rows?.map((item) => (
          <li key={item._uid} className={styles.item}>
            <Item
              {...item}
              onClick={() => handleLinkClick(column.title, item.text)}
            />
          </li>
        ))}
      </ul>
      {children}
    </div>
  );
};
